"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnersDb = void 0;
const isomorphic_unfetch_1 = __importDefault(require("isomorphic-unfetch"));
const assets_1 = require("../helpers/assets");
const partner_model_1 = require("./partner.model");
class PartnerDb {
    static addPartner(partner) {
        if (!PartnerDb.partnersDb[partner.getSlug()]) {
            const partner = new partner_model_1.PartnerModel();
            PartnerDb.partnersDb[partner.getSlug()] = partner;
        }
    }
    static getPartner(slug) {
        if (!PartnerDb.partnersDb[slug]) {
            return null;
        }
        const partner = PartnerDb.partnersDb[slug];
        return partner === undefined || partner == null ? null : partner;
    }
    static async loadDb(fetcher = null, dbUrl = PartnerDb.DEFAULT_DEV_DB_URL, assetsConfig = null) {
        PartnerDb.assetsConfig = assetsConfig;
        await PartnerDb.fetchData(fetcher, dbUrl);
        return PartnerDb.partnersDb;
    }
    static getDbSynch() {
        return PartnerDb.partnersDb;
    }
    static importDb(partnerDbMapSerialized) {
        const serializedPartners = JSON.parse(partnerDbMapSerialized);
        for (const partnerSerialized of Array.from(Object.values(serializedPartners))) {
            if (!partnerSerialized || partnerSerialized === null) {
                continue;
            }
            else {
                const partner = (0, assets_1.configurePartnerAssets)(partner_model_1.PartnerModel.fromJSON(partnerSerialized), PartnerDb.assetsConfig);
                PartnersDb.partnersDb[partner.slug] = partner;
                PartnersDb.partnersSlugIdMap[partner.idPartner] = partner.slug;
            }
        }
    }
    static exportDb() {
        return JSON.stringify(PartnerDb.partnersDb);
    }
    static async fetchData(fetcher = null, dbUrl) {
        if (Object.keys(PartnerDb.partnersDb).length == 0) {
            const fetch = fetcher ? fetcher : isomorphic_unfetch_1.default;
            await fetch(dbUrl)
                .then((r) => r.text())
                .then((partnerDbSerialized) => {
                PartnersDb.importDb(partnerDbSerialized);
            });
        }
        return PartnerDb.partnersDb;
    }
    static size() {
        return Object.keys(PartnersDb.partnersDb).length;
    }
    static getPartnerById(partnerId) {
        if (PartnersDb.partnersSlugIdMap[partnerId] && PartnersDb.partnersDb[PartnersDb.partnersSlugIdMap[partnerId]]) {
            return PartnersDb.partnersDb[PartnersDb.partnersSlugIdMap[partnerId]];
        }
        return null;
    }
}
PartnerDb.DEFAULT_DEV_DB_URL = "https://prod-datalayer-24orebs-storage.s3.eu-central-1.amazonaws.com/websitedata/partners/published_partners_db.json";
PartnerDb.partnersDb = {};
PartnerDb.partnersSlugIdMap = [];
PartnerDb.assetsConfig = null;
const PartnersDb = PartnerDb;
exports.PartnersDb = PartnersDb;
//# sourceMappingURL=partnersdb.js.map